const SPECIAL_HIGHLIGHTED_ITEM = 'specialHighlightedItem';
const OFFERS_ITEM = 'offersItem';

export { OFFERS_ITEM, SPECIAL_HIGHLIGHTED_ITEM };
